import requestProvider from "./axiosHandler";

const getAllWarehouse = () => {

    return requestProvider
        .get('/warehouse/get-all')
};

const createWarehouse = (list) => {

    return requestProvider
        .post('/warehouse', {
            name: list.name,
            code: list.code,
            description: list.description,
            address: list.address,
            phone: list.phone,
            representative: list.representative,
            shareStock: list.shareStock
        })
};

const deleteWarehouse = (id) => {

    return requestProvider
        .delete(`/warehouse/${id}`)
};

const updateWarehouse = (list) => {

    return requestProvider
        .put('/warehouse', {
            name: list.name,
            code: list.code,
            description: list.description,
            address: list.address,
            phone: list.phone,
            representative: list.representative,
            id: list.id,
            shareStock: list.shareStock
        })
};

const getWarehouseById = (id) => {

    return requestProvider
        .get(`/warehouse/${id}`)
};

const getWarehousesWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/warehouse?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
};

export {createWarehouse, deleteWarehouse, updateWarehouse, getAllWarehouse, getWarehouseById, getWarehousesWithPage}